import { getInventWidgetRuntimeConfig } from "@/server/invent-widget"

let portalOriginRequest: Promise<string> | undefined

export function getInventPortalOrigin(): Promise<string> {
  if (!portalOriginRequest) {
    const request = getInventWidgetRuntimeConfig().then((config) => config?.portalOrigin ?? "")
    portalOriginRequest = request

    void request.catch(() => {
      if (portalOriginRequest === request) {
        portalOriginRequest = undefined
      }
    })
  }

  return portalOriginRequest
}

export function clearInventPortalOrigin(): void {
  portalOriginRequest = undefined
}
